import PropTypes from 'prop-types';

const propTypes = {
  when: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number,
  ]),
  defaultValue: PropTypes.node,
  children: PropTypes.node.isRequired,
};

const defaultProps = {
  when: false,
  defaultValue: null,
};

const Only = ({
  when,
  defaultValue,
  children,
}) => (when ? children : defaultValue);

Only.propTypes = propTypes;
Only.defaultProps = defaultProps;

export default Only;
